import { httpClient, IHttpClient } from '@api'

import { TPaymentGatewayResponse } from '../types/TPaymentGatewayResponse'

interface IPaymentGatewayClient {
  getGateways(applicationUuid: string): Promise<TPaymentGatewayResponse[]>
}
const paymentGatewayClientFactory = (
  client: IHttpClient,
): IPaymentGatewayClient => {
  return {
    getGateways(applicationUuid: string): Promise<TPaymentGatewayResponse[]> {
      return client.get(`/client/v1/${applicationUuid}/payment-gateways`)
    },
  }
}

export const paymentGatewayClient: IPaymentGatewayClient =
  paymentGatewayClientFactory(httpClient)
